<button (click)="addToCart($event)" class="add-btn">
  <span class="add-icon"></span>
</button>
